import React from "react";
import { Select, Input } from "@/components/erp/ui";
import { taxLabel } from "@/lib/tax";

// Pilih satu pajak dari Pusat Pajak (+ isian nilai bila tipe manual)
export const TaxPicker = ({ taxes, value, manual, onChange, testid = "tax" }) => {
  const t = taxes.find(value);
  return (
    <div className="flex items-center gap-2 justify-end flex-wrap">
      <Select data-testid={`${testid}-select`} className="!w-auto max-w-[240px] !py-1" value={value || taxes.default_id || "none"} onChange={(e) => onChange(e.target.value, manual)}>
        <option value="none">Tanpa Pajak</option>
        {taxes.items.map((x) => <option key={x.id} value={x.id}>{taxLabel(x)}{x.id === taxes.default_id ? " — default" : ""}</option>)}
      </Select>
      {t?.type === "manual" && <Input type="number" data-testid={`${testid}-manual`} placeholder="Nilai pajak (Rp)" className="!w-32 !py-1 text-right" value={manual ?? ""} onChange={(e) => onChange(value, e.target.value)} />}
    </div>
  );
};
